<template>
  <div class="v2-header">
    <div class=" v2-container">
      <div class="d-flex">
        <div ref="nav" class="v2-header-nav" @mouseleave="onNavleave">
          <a
            href="#about"
            @mouseover="onMouseover"
            @mouseleave="onMouseleave"
            class="v2-header-nav__link js-scrollto"
            >About</a
          >
          <a
            href="#projects"
            @mouseover="onMouseover"
            @mouseleave="onMouseleave"
            class="v2-header-nav__link js-scrollto"
            >Projects</a
          >
          <a
            href="#contacts"
            @mouseover="onMouseover"
            @mouseleave="onMouseleave"
            class="v2-header-nav__link js-scrollto"
            >Contacts</a
          >
          <div class="v2-header-nav__line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenMax, TimelineMax } from "gsap/TweenMax";

export default {
  name: "V2Header",

  data() {
    return {};
  },
  computed: {},
  mounted() {
    require("@/utils/scroll-to-anchor.js");
  },
  destroyed() {},

  methods: {
    onMouseover(e) {
      var link = e.target;

      var linkWidth = link.offsetWidth;
      var linkOffset = link.offsetLeft;

      var line = document.querySelector(".v2-header-nav__line");
      var lineWidth = line.offsetWidth;

      if (lineWidth) {
        //hover from other link
        var tl = new TimelineMax()
          .to(line, 0, {
            scale: 1,
          })
          .to(line, 0.5, {
            width: linkWidth,
            x: linkOffset,
          });
      } else {
        //hover from outside nav
        new TimelineMax()
          .to(line, 0, {
            x: linkOffset,
          })
          .to(line, 0, {
            scale: 1,
          })
          .to(line, 0.5, {
            width: linkWidth,
          });
      }
    },
    onMouseleave(e) {},
    onNavleave() {
      var el = ".v2-header-nav__line";
      var tl = new TimelineMax().to(el, 0, {
        width: 0,
        x: 0,
        scale: 0,
      });
    },
  },
};
</script>
